import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Profile\ProfilePreferencesController::index
* @see Http/Controllers/Profile/ProfilePreferencesController.php:12
* @route '/profile/preferences'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/profile/preferences',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Profile\ProfilePreferencesController::index
* @see Http/Controllers/Profile/ProfilePreferencesController.php:12
* @route '/profile/preferences'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Profile\ProfilePreferencesController::index
* @see Http/Controllers/Profile/ProfilePreferencesController.php:12
* @route '/profile/preferences'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Profile\ProfilePreferencesController::index
* @see Http/Controllers/Profile/ProfilePreferencesController.php:12
* @route '/profile/preferences'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PreferencesController::update
* @see Http/Controllers/PreferencesController.php:19
* @route '/profile/preferences'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/profile/preferences',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\PreferencesController::update
* @see Http/Controllers/PreferencesController.php:19
* @route '/profile/preferences'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PreferencesController::update
* @see Http/Controllers/PreferencesController.php:19
* @route '/profile/preferences'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\PreferencesController::mobileNavOrder
* @see Http/Controllers/PreferencesController.php:33
* @route '/profile/preferences/mobile-nav-order'
*/
export const mobileNavOrder = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: mobileNavOrder.url(options),
    method: 'put',
})

mobileNavOrder.definition = {
    methods: ["put"],
    url: '/profile/preferences/mobile-nav-order',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\PreferencesController::mobileNavOrder
* @see Http/Controllers/PreferencesController.php:33
* @route '/profile/preferences/mobile-nav-order'
*/
mobileNavOrder.url = (options?: RouteQueryOptions) => {
    return mobileNavOrder.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PreferencesController::mobileNavOrder
* @see Http/Controllers/PreferencesController.php:33
* @route '/profile/preferences/mobile-nav-order'
*/
mobileNavOrder.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: mobileNavOrder.url(options),
    method: 'put',
})

const preferences = {
    index: Object.assign(index, index),
    update: Object.assign(update, update),
    mobileNavOrder: Object.assign(mobileNavOrder, mobileNavOrder),
}

export default preferences